import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { CupFilledIcon } from '@icons';

import { useModals } from '@shared/contexts';

import { UserPromotionCardType } from '@types';

import { Button } from '@components/button';
import { ModalName } from '@components/modals';

import * as Styled from './recent-promotion-card.styled';

type OwnProps = {
	promo: UserPromotionCardType;
};

const RecentPromotionCard: React.FC<OwnProps> = ({ promo }) => {
	const navigate = useNavigate();
	const { t } = useTranslation('main');
	const { openModal } = useModals();

	const handleButtonClick = (promo: UserPromotionCardType) => {
		if (promo.position) {
			openModal(ModalName.PROMOTION_WINNER, { winner: promo });
			return;
		}

		if (promo.status === 'completed') {
			navigate('/completed-promotion/' + promo.id, { state: { promotionId: promo.id } });
			return;
		}

		navigate('/promotion', { state: { promotionId: promo.id } });
	};

	const handleWinnersList = () => {
		openModal(ModalName.PROMOTION_WINNERS_LIST, { winnerList: promo.prize.winners });
	};

	return (
		<Styled.Wrapper $place={promo.position}>
			<Styled.ChipWrapper>
				<Styled.Chip>
					{promo.position === null
						? promo.status === 'active'
							? t('active_status')
							: promo.status === 'pending'
								? t('pending_status')
								: t('ended_status')
						: promo.position + ' ' + t('place')}
				</Styled.Chip>
				{promo.multiple_prize && (
					<Styled.WinnerCount>{t('winners_dec') + ': ' + promo.prize.winners.length}</Styled.WinnerCount>
				)}
			</Styled.ChipWrapper>
			<Styled.Title>{promo.name}</Styled.Title>
			{promo.position !== null && promo.prize.name && (
				<>
					{!promo.multiple_prize && <Styled.Prize>{t('prize')}</Styled.Prize>}
					<Styled.PrizeName>
						<Styled.CupIconWrapper>
							<CupFilledIcon />
						</Styled.CupIconWrapper>
						{promo.prize.name}
					</Styled.PrizeName>
				</>
			)}
			<Styled.ButtonWrapper>
				{promo.multiple_prize && (
					<Button onClick={handleWinnersList} size='small' color='dark'>
						{t('winners')}
					</Button>
				)}
				<Button onClick={() => handleButtonClick(promo)} color={promo.multiple_prize ? 'light' : 'dark'} size='small'>
					{promo.multiple_prize ? t('receive_prize') : promo.status === 'completed' ? t('results') : t('readMoreBtn')}
				</Button>
			</Styled.ButtonWrapper>
		</Styled.Wrapper>
	);
};

export default RecentPromotionCard;
